export const GUIDED_SAMPLE_SESSION_KEY = "linebyline-guided-sample";
export const GUIDED_SAMPLE_TITLE = "The Tempest — Guided Rehearsal";

export const GUIDED_SAMPLE_TEXT = `${GUIDED_SAMPLE_TITLE}
#Page1
@PROSPERO Be collected: no more amazement. Tell your piteous heart there's no harm done.
@MIRANDA O, woe the day!
@PROSPERO No harm. I have done nothing but in care of thee, my dear one, thee, my daughter.
@MIRANDA If by your art, my dearest father, you have put the wild waters in this roar, allay them.
(Prospero lays down his mantle.)
@PROSPERO 'Tis time I should inform thee farther. Lend thy hand, and pluck my magic garment from me.
@MIRANDA Alack, what trouble was I then to you!
@PROSPERO O, a cherubin thou wast that did preserve me. Thou didst smile, infused with a fortitude from heaven.
#Page2
@MIRANDA Wherefore did they not that hour destroy us?
@PROSPERO Dear, they durst not, so dear the love my people bore me.
@MIRANDA How came we ashore?
@PROSPERO By Providence divine. Some food we had and some fresh water that a noble Neapolitan, Gonzalo, did give us.
@MIRANDA Would I might but ever see that man!
@PROSPERO Now I arise. Sit still, and hear the last of our sea-sorrow.
(Prospero resumes his mantle.)
@MIRANDA Your tale, sir, would cure deafness.`;

export function queueGuidedSample(storage: Pick<Storage, "setItem"> = sessionStorage): void {
  storage.setItem(GUIDED_SAMPLE_SESSION_KEY, JSON.stringify({ title: GUIDED_SAMPLE_TITLE, text: GUIDED_SAMPLE_TEXT }));
}

export function consumeGuidedSample(storage: Pick<Storage, "getItem" | "removeItem"> = sessionStorage): { title: string; text: string } | undefined {
  const source = storage.getItem(GUIDED_SAMPLE_SESSION_KEY);
  if (!source) return undefined;
  storage.removeItem(GUIDED_SAMPLE_SESSION_KEY);
  try {
    const sample = JSON.parse(source) as Record<string, unknown>;
    if (typeof sample.title === "string" && typeof sample.text === "string") return { title: sample.title, text: sample.text };
  } catch { /* Ignore invalid session-only sample data. */ }
  return undefined;
}
